import React, { useCallback, useRef } from 'react';
import { ProductCardWithStockStatus } from '../../CategoryPage/RefinedProductCard';
import { styled } from 'linaria/react';
import { standardText } from './allcomponents';
import { cx } from 'linaria';
import { theme } from '../../Theme';
import { useTracking } from '../../../utils/tracking/useTracking';
import { useInViewTracking } from '../../../utils/tracking/useInViewTracking';

const ProductRowWrapper = styled('div')`
  max-width: 90rem;
  width: 100%;
  margin: 1rem auto;

  .text {
    max-width: 45rem;
    padding: 1rem;
    margin: auto;
  }
  a {
    color: black;
  }
  ul.products {
    max-width: 100%;
    gap: 1rem;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(${props => props.perRow}, 1fr);
    li {
      width: 100%;
    }
    ${theme.below.lg} {
      grid-template-columns: repeat(3, 1fr);
      padding: 0 1rem;
    }
    ${theme.below.md} {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;

export const ProductRow = ({ children, text }) => {
  const { trackViewItemList } = useTracking();
  const perRow = children.length < 5 ? children.length : 5;

  // Extract products from children
  const products = React.Children.map(
    children,
    child => child?.props?.product?.value
  ).filter(Boolean);

  // Track when product row comes into view
  const hasTrackedRef = useRef(false);

  const handleInView = useCallback(() => {
    if (hasTrackedRef.current) return;
    if (!products || products.length === 0) return;

    trackViewItemList({
      products,
      listName: 'Product Row',
      listId: 'product_row'
    });

    hasTrackedRef.current = true;
  }, [products, trackViewItemList]);

  // Reset tracking flag when products change
  React.useEffect(() => {
    hasTrackedRef.current = false;
  }, [products]);

  const trackingRef = useInViewTracking(handleInView, {
    threshold: 0.3,
    triggerOnce: true
  });

  // Clone children and add tracking props (listName and index)
  const childrenWithProps = React.Children.map(children, (child, index) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        listName: 'Product Row',
        index
      });
    }
    return child;
  });

  return (
    <ProductRowWrapper
      ref={trackingRef}
      perRow={perRow}
      className="contentComponent"
    >
      {text?.value && (
        <div
          dangerouslySetInnerHTML={{ __html: text.value }}
          className={cx('text', standardText)}
        />
      )}
      <ul className="products">{childrenWithProps}</ul>
    </ProductRowWrapper>
  );
};

const ProductBox = ({ product, listName, index }) => {
  if (!product.value) return null;
  return (
    <>
      <ProductCardWithStockStatus
        product={product.value}
        listName={listName}
        index={index}
      />
    </>
  );
};

export default ProductBox;
